module.exports = __webpack_public_path__ + "img/3.66700b93.jpg";